import React, { useState, useRef, useEffect, CSSProperties }  from 'react';
import { Chart, registerables } from 'chart.js';
import hexToRgba from 'hex-to-rgba';
import { getTooltip } from '../../model/Chart';
import { ChartDataset } from '../../model/ChartDataset';
Chart.register(...registerables);

const MultiAxisLineChart = ({ datasets, labels, height, displayAxes }: Props) => {
  const defaultTicksColor = '#6F6B7D';
  const chartRef = useRef<HTMLCanvasElement>(null);
  const [chart, setChart] = useState<any>(null);

  useEffect(() => {
    if(chart) {
      chart.destroy();
    }
    if(chartRef.current) {
      for(let dataset of datasets) {
        const d: any = dataset;
        const color = hexToRgba(d.color || '#1ACBE6', 1);
        const lastColor = hexToRgba(d.color || '#1ACBE6', 0);
        const gradient = chartRef.current.getContext('2d').createLinearGradient(0, 0, 0, height ? height / 1.3 : 200);
        gradient.addColorStop(0, color);   
        gradient.addColorStop(1, lastColor);
        d.pointRadius = 10;
        d.pointBorderWidth = 0;
        d.pointBackgroundColor = lastColor,
        d.pointHoverRadius = 10;
        d.pointHoverBorderWidth = 0;
        d.pointHoverBackgroundColor = lastColor,
        d.cubicInterpolationMode = 'monotone';
        d.borderColor = color;
        d.backgroundColor = gradient;
      }
      datasets.length === 2 && (datasets[1].yAxisID = 'y1');
      const c = new Chart(chartRef.current, {
        type: 'line',
        data: {
          labels: labels,
          datasets: datasets
        },
        options: {
          color: '#6F6B7D',
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          plugins: {
            legend: {
              align: 'start',
              labels: {
                usePointStyle: true,
                boxWidth: 7
              }
            },
            tooltip: getTooltip()
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            x: {
              display: displayAxes,
              min: 0,
              grid: {
                display: true,
                color: '#F2F3F7'
              },
              ticks: {
                color: '#6F6B7D'
              }
            },
            y: {
              display: displayAxes,
              grid: {
                display: true,
                color: '#F2F3F7'
              },
              ticks: {
                color: datasets.length === 2 ? datasets[0].color || defaultTicksColor : defaultTicksColor
              },
              position: 'left'
            },
            y1: {
              display: displayAxes,
              grid: {
                drawOnChartArea: false
              },
              ticks: {
                color: datasets.length === 2 ? datasets[1].color || defaultTicksColor : defaultTicksColor
              },
              position: 'right'
            }
          },
        }
      });
      setChart(c);
    }
  }, [ datasets, labels ]);

  const style: CSSProperties = {};
  if(height) {
    style.height = height;
  }
  return (
    <div style={style}>
      <canvas ref={chartRef}></canvas>
    </div>
  );
}


interface Props {
  datasets: ChartDataset[],
  labels: string[],
  height: number,
  displayAxes: boolean
}

export { MultiAxisLineChart };